<template>
	<div id="login-modal">
		<SwitchLanguage />
		<form @submit.prevent="onSubmit">
			<input ref="loginEmailInput" type="text" name="email" :placeholder="$t('user.inputYourEmail')" v-model="email" required>
			<input type="password" name="password" :placeholder="$t('user.password')" v-model="password" required>
			<button type="submit" class="login-submit">{{ $t("user.loginButton") }}</button>
		</form>
		<button type="button" class="lost-password" @click="lostPassword">{{ $t('user.lostPassword') }}</button>
		<!--<div class="or">nebo</div>
		<button type="button" class="facebook" @click="onFacebook">Přihlásit se přes Facebook</button>-->
	</div>
</template>

<script>
	import Vue from "vue";
	import { auth } from "@/firebase";
	import firebase from "firebase";
	import SwitchLanguage from "../language/SwitchLanguage";

	export default {
		name: "LoginTab",
		components: {SwitchLanguage},
		data() {
			return {
				email: null,
				password: null
			};
		},
		methods: {
			opened() {
				Vue.nextTick(() => {
					this.$refs.loginEmailInput.focus();
				});
			},
			onSubmit() {
				if (this.$store.state.networkOnline !== true) {
					this.$notify({
						type: "error",
						text: this.$t('error.checkInternet'),
					});
					return;
				}

				if (this.email === null || this.email.length < 5) {
					this.$notify({
						type: "error",
						text: this.$t('error.fillEmail'),
					});
				} else if (this.password === null || this.password.length === 0) {
					this.$notify({
						type: "error",
						text: this.$t('error.fillPassword'),
					});
				} else {
					this.$store.commit("setLoading", true);
					let anonymousUid = null;
					if (this.$store.state.currentUser.isAnonymous) {
						anonymousUid = this.$store.state.currentUser.uid;
					}

					auth.signInWithEmailAndPassword(this.email, this.password)
						.then(() => {
							/* eslint-disable */ ga("send", "event", "Sign in", "submit");
							if (anonymousUid) {
								const functionSyncAccounts = firebase.functions().httpsCallable("syncAccounts");
								functionSyncAccounts({ anonymousUid: anonymousUid });
							}

							this.$store.commit("setLoading", false);
							this.$modal.hide("login-registration");
							this.$modal.hide("login-registration-force");
							this.$notify({
								type: "success",
								text: this.$t('success.login'),
							});
						})
						.catch(error => {
							this.$store.commit("setLoading", false);
							if (error.code === "auth/wrong-password") {
								this.$notify({
									type: "error",
									text: this.$t('error.wrongPassword'),
								});
							}

							if (error.code === "auth/invalid-email") {
								this.$notify({
									type: "error",
									text: this.$t('error.emailInvalid'),
								});
							}

							if (error.code === "auth/user-not-found") {
								this.$notify({
									type: "error",
									text: this.$t('error.emailDoesntExist'),
								});
							}
						});
				}
			},
			lostPassword() {
				if (this.email === null || this.email.length < 5) {
					this.$notify({
						type: "error",
						text: this.$t('error.lostFillPassword'),
					});
				} else {
					this.$store.commit("setLoading", true);
					auth.sendPasswordResetEmail(this.email)
						.then(() => {
							this.$store.commit("setLoading", false);
						})
						.catch((error) => {
							setTimeout(() => {
								this.$store.commit("setLoading", false);
							}, 1000);
							if (error.code === "auth/argument-error") {
								this.$notify({
									type: "error",
									text: this.$t('error.lostFillPassword'),
								});
							}
						});
				}
			},
			onFacebook() {
				var provider = new firebase.auth.FacebookAuthProvider();
				auth.signInWithPopup(provider).then(() => {
					this.$modal.hide("login");
					//var token = result.credential.accessToken;
					//var user = result.user;
				}).catch(function() {
					//var errorCode = error.code;
					//var errorMessage = error.message;
					//var email = error.email;
					//var credential = error.credential;
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	#login-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-size: 1.1em;

		.or {
			text-align: center;
			margin-bottom: 20px;
		}

		input {
			width: 87%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			background-color: rgba(255, 255, 255, 0.21);
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin-bottom: 1px;

			&::placeholder {
				color: rgba(255, 255, 255, 0.49);
			}

			&:focus {
				outline: none;
			}
		}

		button.login-submit {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			background: rgb(233,196,106); /* Old browsers */
			background: -moz-linear-gradient(left, rgba(233,196,106,1) 1%, rgba(244,162,97,1) 100%); /* FF3.6-15 */
			background: -webkit-linear-gradient(left, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* Chrome10-25,Safari5.1-6 */
			background: linear-gradient(to right, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e9c46a', endColorstr='#f4a261',GradientType=1 ); /* IE6-9 */
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin: 20px 0;
			cursor: pointer;

			&:hover {
				opacity: 0.9;
			}
		}

		button.facebook {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e9c46a', endColorstr='#f4a261',GradientType=1 ); /* IE6-9 */
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin: 20px 0 1px 0;
			cursor: pointer;

			background-color: #4267b2;
			color: #e0e2f7;
			display: block;
			text-align: center;
			font-size: 1.2em;

			&:hover {
				background-color: #3a5b9d;
			}
		}

		button.lost-password {
			opacity: 0.7;
			font-weight: 100;
			margin: 5px 20px;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 40px;
			background-color: #356173;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			border-radius: 4px;
			width: 260px;

			&:hover {
				opacity: 1;
				background-color: #2f4f5f;
			}

			&:focus {
				outline: none;
			}
		}

	}
</style>
